import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/switchMap';
import { shouldDisplayDialog } from '../../../services/board-issue-move/index.tsx';
import { SET_APP_DATA } from '../../../state/actions/app/index.tsx';
import { boardIssueMoveShow } from '../../../state/actions/board-issue-move/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(SET_APP_DATA)
		.take(1)
		.switchMap(() =>
			shouldDisplayDialog(store.getState()).flatMap((shouldDisplay) =>
				shouldDisplay ? Observable.of(boardIssueMoveShow()) : Observable.empty<never>(),
			),
		);
